import type { StepState, WidgetState } from '../types';
import type { StepProps } from '../useStepForm';
import type { Modify, PartialBy } from '@toolbox/utils';

export type InitialWidgetState = Modify<
  Partial<Omit<WidgetState, 'stepPropsMap'>>,
  {
    history?: PartialBy<StepState, 'skipped' | 'formData'>[];
  }
>;

export function initState({
  steps,
  activeId,
  history,
  stepDataMap = {},
}: InitialWidgetState & {
  steps: StepProps[];
}): WidgetState {
  const historyState = history?.length
    ? history
    : [
        {
          id: activeId || (steps[0]?.id as string),
          formData: {},
          skipped: false,
        },
      ];
  return {
    stepDataMap,
    stepPropsMap: steps.reduce(
      (propsMap, stepProps) => ({
        ...propsMap,
        [stepProps.id]: stepProps,
      }),
      {},
    ),
    history: historyState.map((step) => ({
      ...step,
      formData: step.formData ?? {},
      skipped: !!step.skipped,
    })),
    activeId: activeId || (historyState[historyState.length - 1]?.id as string),
  };
}
